export enum ActionType {
  ShowFilter,
  HandleChip,
  ShowTopup,
}

export interface ShowFilter {
  type: ActionType.ShowFilter;
}

export interface ShowTopup {
  type: ActionType.ShowTopup;
  payload: {
    status: boolean;
    id: number
  }
}

export interface HandleChip {
  type: ActionType.HandleChip;
  payload: any[];
}

export type InvoiceAction = ShowFilter | HandleChip | ShowTopup;
